import { Routes } from '@angular/router';
import { loginRoutes } from '@capturum/login';
import { IndexedDbGuard, PublicTranslationResolver } from '@capturum/complete';
import { AuthGuard } from '@capturum/auth';
import { DentalCompleteResolver } from '@core/resolvers/dental-complete.resolver';
import { FormBuilderResolver } from './features/client/form-builder/resolvers/form-builder.resolver';

export const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'client',
    pathMatch: 'full',
  },
  {
    path: loginRoutes[0].path,
    loadChildren: () => {
      return import('./features/auth/routes').then((m) => {
        return m.default;
      });
    },
    canActivate: [IndexedDbGuard],
    resolve: {
      publicTranslations: PublicTranslationResolver,
    },
  },
  {
    path: 'client',
    loadChildren: () => {
      return import('./features/client/routes').then((m) => {
        return m.default;
      });
    },
    canActivate: [IndexedDbGuard, AuthGuard],
    resolve: {
      complete: DentalCompleteResolver,
      formBuilders: FormBuilderResolver,
    },
  },
  {
    path: 'power-bi',
    loadChildren: () => {
      return import('@capturum/powerbi/pages').then((m) => {
        return m.CapturumPowerBIPagesModule;
      });
    },
  },
  {
    path: '**',
    redirectTo: 'client',
  },
];
